import React from 'react';
import axios from 'axios';
import { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';

function ModificationCandidature(props) {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [commentaire, setCommentaire] = useState(props.status.commentaire_arbitre);
    const [status, setStatus] = useState()
    const apiUrl = process.env.REACT_APP_API_URL;


    const handleSubmitModif = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setConfirmation(false);
      
      try {
        await axios.patch(`${apiUrl}/arbitrage/candidature/modifier`, {
          commentaireArbitre : commentaire,
          idCandidature : props.status.id_candidature
        }, {
          withCredentials: true
        });
  
        setError(null);
        setIsLoading(false);
        window.location.reload(); 

      } catch (error) {
        console.log(error)
        if (error.response) {
          setIsLoading(false)
          setError(error.response.data.message);
        } else {
          setIsLoading(false)
          setError(true);
        }
      }
    };

    const handleSubmitSupp = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setConfirmation(false);
      
      try {
        await axios.delete(
          `${apiUrl}/arbitrage/candidature/supprimer`,
          {
              withCredentials: true, // Inclut les cookies dans la requête
              data: {
                  commentaireArbitre: commentaire,
                  idCandidature: props.status.id_candidature
              }
          }
      );
  
        setError(null);
        setIsLoading(false);
        window.location.reload(); 

      } catch (error) {
        if (error.response) {
          setIsLoading(false)
          setError(error.response.data.message);
        } else {
          setIsLoading(false)
          setError(true);
        }
      }
    };

  
        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }
        if(error){
            return (
                <>
                <div id="alert-message" className="alert4" >
                    <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                </div>
              </>  
            )
        }

  return (
    <>
    {confirmation && (
      <>
        <Modal show={confirmation} onHide={() => {setConfirmation(false);setStatus()}}>
                <Modal.Header closeButton>
                  <Modal.Title>{status} votre candidature</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <>Voulez-vous vraiment {status} votre candidature pour ce match ?</>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => {setConfirmation(false);setStatus()}} >
                    Quitter
                  </Button>
                  <Button variant="primary" onClick={(e) => status === 'Modifier' ? handleSubmitModif(e) : handleSubmitSupp(e)}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                    Confirmer
                  </Button>
                </Modal.Footer>
        </Modal>
      </>
    )}
    {props.equipe && 
        <>
          <Card.Header></Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Card.Text>Votre candidature est toujours en attente.</Card.Text>
            <Card.Text><strong>Modifier la candidature</strong> </Card.Text>
              <Form.Label>Commentaire</Form.Label>
              <Form.Control as="textarea" value={commentaire} onChange={(e) => setCommentaire(e.target.value)} rows={3}  />
            </Form.Group>
            <Button variant="primary" onClick={() => {setConfirmation(true); setStatus('Supprimer')}}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Supprimer la candidature </Button>
            &nbsp;&nbsp;
            <Button variant="primary" onClick={() => {setConfirmation(true); setStatus('Modifier')}}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Modifier la candidature </Button>
          </Card.Body> 
        </>
    }


    </>
  );
}

export default ModificationCandidature;